import header from './modules/header.js';
import { toggableItemGrid, slowScrollLinks } from './modules/helpers.js';
import { lenisAnimation } from './modules/lenis.js';
import { websiteAnimations } from './modules/websiteAnimation.js';
import { generalJS, customizeSelect } from './modules/general.js';
import './modules/video-stack-animation.js';
import './modules/default-animations.js';
import './modules/forms.js';
import './modules/animacion-smartphone.js';
import './modules/popup-soluciones.js';
import './modules/slider-otros-aliados.js';
import './modules/animacion-seccion-impacto.js';
import './modules/contador-home.js';
import './modules/activar-desactivar-audio.js';

/**
 * Lenis Scroll
 */
lenisAnimation().then(() => {
	/**
	 * Header
	 */
	if (document.querySelector('.header')) header();

	/**
	 * Helpers functions, uncomment if used
	 */
	toggableItemGrid();

	slowScrollLinks();

	/**
	 * General JS Code
	 */
	generalJS();
	customizeSelect();
});

/**
 * Alpine JS
 */
document.addEventListener('alpine:init', () => {
	Alpine.data('websiteAnimations', websiteAnimations);
});
